// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:959px){.ftr__link[data-v-9f5f377a]{margin-bottom:1.75rem}}@media (min-width:960px){.ftr__link[data-v-9f5f377a]:not(:last-child){margin-bottom:1rem}}", ""]);
// Exports
module.exports = exports;
